<ng-container *samwebVar="messageInfo$ | async; let messageInfo">
   <samweb-window
      [id]="messageId"
      [type]="type"
      [titleBarIcon]="envelope"
      [titleBarHeader]="(email$ | async)?.subject"
      [titleBarAdditionalInfo]="
         (showToInHeader && (emailRecipient$ | async)?.length > 0) || (isEditable$ | async)
            ? (emailRecipient$ | async)
            : !showToInHeader && (email$ | async)?.from.length > 0 && !(isEditable$ | async)
            ? (email$ | async)?.from
            : ''
      "
      (cancel)="onCancel(messageInfo)"
      kendoTooltip
      showOn="none"
      #closeTooltipDirective="kendoTooltip"
      [tooltipTemplate]="closeDialog"
      tooltipClass="tooltip-email-window-close-dialog"
   >
      <fieldset [disabled]="isLoading$ | async" class="fieldset">
         <ng-container *ngIf="!(isEditable$ | async)">
            <ng-container *ngIf="(messageInfo$ | async) !== null; else waitlistMessageNotFound">
               <ng-container *ngIf="(messageInfo$ | async)?.messageId !== null">
                  <ng-container *ngIf="(email$ | async) !== null; else noSearchResultFound">
                     <ng-container *ngTemplateOutlet="reader"></ng-container>
                  </ng-container>
               </ng-container>
            </ng-container>
         </ng-container>
         <ng-container *ngIf="isEditable$ | async">
            <ng-container *ngTemplateOutlet="editor"></ng-container>
         </ng-container>
      </fieldset>
   </samweb-window>

   <ng-template #closeDialog>
      <div (samwebOutsideClick)="onCloseDialogCancel(messageInfo)">
         <samweb-email-confirm-close-dialog
            (complete)="onCloseDialogDone(messageInfo)"
            (reassign)="onCloseDialogReassign(messageInfo)"
            (cancel)="onCloseDialogCancel(messageInfo)"
         ></samweb-email-confirm-close-dialog>
      </div>
   </ng-template>

   <ng-template #reader>
      <samweb-email-reader-window
         [email]="email$ | async"
         [attachments]="attachments$ | async"
         [messageInfo]="messageInfo"
      ></samweb-email-reader-window>
   </ng-template>
   <ng-template #editor>
      <samweb-email-editor-window
         [messageId]="messageId"
         [email$]="email$"
         [hasReferenceMail$]="hasReferenceMail$"
         (uploadCanceled)="attachmentUploadCanceled($event)"
      ></samweb-email-editor-window>
   </ng-template>
   <ng-template #waitlistMessageNotFound>
      <div fxLayout="column" fxFlexFill>
         <div class="sam-form-row sam-center" fxFlexFill style="overflow: hidden">
            <fa-icon [icon]="warningIcon" size="5x"></fa-icon>
            <div style="font-weight: bold; margin-top: 1em; margin-bottom: 2em">
               {{ 'samwin.email_dialog.error_handling.message_not_found' | translate }}
            </div>
         </div>
      </div>
   </ng-template>
   <ng-template #noSearchResultFound>
      <div fxLayout="column" fxFlexFill>
         <div class="sam-form-row sam-center" fxFlexFill style="overflow: hidden">
            <fa-icon [icon]="warningIcon" size="5x"></fa-icon>
            <div style="font-weight: bold; margin-top: 1em; margin-bottom: 2em">
               {{ 'samwin.email_dialog.error_handling.loading_content_failed' | translate }}
            </div>
            <div class="sam-form-flex-row">
               <div class="sam-form-row" style="font-weight: bold">
                  <div>{{ 'samwin.email_dialog.message_id' | translate }}</div>
                  <div>{{ 'samwin.email_dialog.folder' | translate }}</div>
                  <div>{{ 'samwin.email_dialog.skill' | translate }}</div>
                  <div>{{ 'samwin.email_dialog.subject' | translate }}</div>
                  <div>{{ 'samwin.email_dialog.address' | translate }}</div>
                  <ng-container *ngIf="messageInfo?.timestamp !== null">
                     {{ 'samwin.email_dialog.date' | translate }}
                  </ng-container>
               </div>
               <div class="sam-form-row sam-margin-left">
                  <div>{{ messageInfo.messageId }}</div>
                  <div>{{ messageInfo?.group }}</div>
                  <div>
                     <samweb-skill-short-info
                        [skills]="messageInfo?.skill?.skills"
                        [skillConfiguration]="messageInfo?.skill?.skillConfiguration"
                     ></samweb-skill-short-info>
                  </div>
                  <div>{{ messageInfo.subject }}</div>
                  <div>{{ messageInfo.address }}</div>
                  <ng-container *ngIf="messageInfo?.timestamp !== null">
                     {{ messageInfo.timestamp | toMoment$ | async | amDateFormat: 'LLL' }}
                  </ng-container>
               </div>
            </div>

            <div>
               <button
                  kendoButton
                  (click)="executeAction(completeAction.value, messageInfo)"
                  *ngIf="
                     messageInfo?.group === inboxFolder ||
                     messageInfo?.group === trackFolder ||
                     messageInfo?.group === deleteFolder
                  "
               >
                  <samweb-icon-with-subicon
                     class="sam-center"
                     [primaryIcon]="completeAction.defaultIcon"
                     [secondaryIcon]="completeAction.subIcon"
                  ></samweb-icon-with-subicon>
                  <div style="flex: '1'; text-align: left; padding-left: 1em">
                     {{ completeAction.translationValue | translate }}
                  </div>
               </button>
               <button
                  kendoButton
                  class="sam-margin-left"
                  *ngIf="
                     messageInfo?.group === inboxFolder ||
                     messageInfo?.group === completeFolder ||
                     messageInfo?.group === deleteFolder
                  "
                  (click)="executeAction(trackAction.value, messageInfo)"
               >
                  <samweb-icon-with-subicon
                     class="sam-center"
                     [primaryIcon]="trackAction.defaultIcon"
                     [secondaryIcon]="trackAction.subIcon"
                  ></samweb-icon-with-subicon>
                  <div style="flex: '1'; text-align: left; padding-left: 1em">
                     {{ trackAction.translationValue | translate }}
                  </div>
               </button>
               <button
                  kendoButton
                  *ngIf="messageInfo?.group === completeFolder || messageInfo?.group === trackFolder"
                  class="sam-margin-left"
                  (click)="executeAction(deleteAction.value, messageInfo)"
               >
                  <samweb-icon-with-subicon
                     class="sam-center"
                     [primaryIcon]="deleteAction.defaultIcon"
                     [secondaryIcon]="deleteAction.subIcon"
                  ></samweb-icon-with-subicon>
                  <div style="flex: '1'; text-align: left; padding-left: 1em">
                     {{ deleteAction.translationValue | translate }}
                  </div>
               </button>
            </div>
         </div>
      </div>
   </ng-template>
</ng-container>
